import React from 'react'

import type { IconProps } from './types'

const SimilacShield: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M23.257 2a53.7 53.7 0 0 1 17.28 2.873 2.77 2.77 0 0 1 1.967 2.88c-.723 6.442-2.993 23.71-4.144 25.596-2.288 3.748-10.458 9.853-13.735 12.214a2.38 2.38 0 0 1-2.747 0c-3.275-2.36-11.436-8.466-13.725-12.214-1.15-1.885-3.421-19.154-4.144-25.596a2.77 2.77 0 0 1 1.967-2.88A53.7 53.7 0 0 1 23.257 2"
        fill="#187466"
      />
      <path
        d="M23.258 4.873A48.4 48.4 0 0 1 38.38 7.308c1.092.367 1.31 1.377 1.193 2.442-.612 5.461-2.536 20.102-3.513 21.7-2.047 3.353-9.643 8.929-12.064 10.657a1.28 1.28 0 0 1-1.493 0c-2.419-1.729-10.006-7.304-12.053-10.656-.974-1.599-2.898-16.24-3.511-21.7-.12-1.066.1-2.075 1.193-2.442a48.4 48.4 0 0 1 15.125-2.436"
        fill="#06AE9B"
      />
      <path
        d="M24.029 16.363h-1.562a2.26 2.26 0 0 0-2.258 2.26v.389a.487.487 0 0 1-.486.486h-.389a2.26 2.26 0 0 0-2.257 2.257v1.563a2.26 2.26 0 0 0 2.257 2.258h.389a.49.49 0 0 1 .486.487v.388a2.26 2.26 0 0 0 2.258 2.258h1.562a2.26 2.26 0 0 0 2.258-2.258v-.391a.487.487 0 0 1 .486-.487h.391a2.26 2.26 0 0 0 2.256-2.257v-1.56a2.26 2.26 0 0 0-2.256-2.258h-.39a.487.487 0 0 1-.488-.487v-.388a2.26 2.26 0 0 0-2.257-2.258z"
        fill="#E6FAF7"
      />
    </svg>
  )
}

export default SimilacShield
